import * as React from 'react';

import { IStyle, mergeStyles } from '@fluentui/react/lib/Styling';
import { toMatrix } from '@fluentui/react/lib/Utilities';

import { AppGalleryButton } from '@1js/acui-gallery';

import { RibbonTableGalleryButtonProps } from './RibbonTableGalleryButton.Props';

/**
 * A gallery button which will consist of a table.
 * One can specify the size of the table using the columns prop
 * and the tableCellStyles (for total number of table cells) prop.
 */
export class RibbonTableGalleryButton extends React.PureComponent<RibbonTableGalleryButtonProps, {}> {
  public render() {
    /* eslint-disable-next-line prefer-const */
    let { columns, tableCellStyles, tableStyles, getTableStyling, id } = this.props;

    // We cannot use DefaultProps with strict null checks enabled in TypeScript.
    // See https://github.com/DefinitelyTyped/DefinitelyTyped/issues/11640.
    if (columns === undefined || columns === 0) {
      columns = 5;
    }

    // Array to store the cells in the correct row index
    const cellStyles = toMatrix(
      tableCellStyles ? tableCellStyles : new Array(columns * columns),
      columns /* columnCount */
    );

    return (
      <AppGalleryButton
        {...this.props}
        automationType="RibbonTableGalleryButton"
        uniqueId={id}
        shouldTakeFocus={this.props.shouldTakeFocus !== undefined ? this.props.shouldTakeFocus : true}
      >
        <table
          aria-hidden={'true'}
          className={mergeStyles(tableStyles, getTableStyling && mergeStyles(getTableStyling().tableStyles))}
        >
          <tbody>
            {cellStyles.map((rows: IStyle[], rowIndex: number) => {
              return (
                <tr key={`${id}-${rowIndex}-row`}>
                  {rows.map((cell: IStyle, cellIndex: number) => {
                    return (
                      <td
                        key={`${id}-${cellIndex}-cell`}
                        className={
                          getTableStyling && mergeStyles(getTableStyling({ tableCellStyles: cell }).tableCellStyles)
                        }
                      >
                        {this.props.tableCellContent}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </AppGalleryButton>
    );
  }
}
